import MomentTimezone from 'moment-timezone';
import { FORMAT_YMD } from '@/components/shared/date-format';

const NO_DATES = {};
const TIMESPAN = {
  DAY: 0,
  LAST_24: 1,
  WEEK: 7
};
export default {
  methods: {
    selectTimespan(option, startStringDate) {
      const startDate = MomentTimezone(startStringDate, FORMAT_YMD);

      if (option === TIMESPAN.DAY) {
        return {
          startDate: startDate.format(FORMAT_YMD),
          endDate: startDate.format(FORMAT_YMD)
        };
      }
      if (option === TIMESPAN.LAST_24) {
        return NO_DATES;
      }
      return {
        endDate: MomentTimezone().format(FORMAT_YMD),
        startDate: startDate.subtract(option, 'd').format(FORMAT_YMD)
      };
    },
    splitHoursMinutes(string) {
      if (string) {
        const hoursAndMinutes = string.split(':');

        return { hours: +hoursAndMinutes[0], minutes: +hoursAndMinutes[1] };
      }
      return { hours: +0, minutes: +0 };
    },
    isValidDate(date) {
      return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
    },
    YMDToString(date) {
      if (this.isValidDate(date)) {
        return [
          date.getFullYear(),
          `0${date.getMonth() + 1}`.slice(-2),
          `0${date.getDate()}`.slice(-2)
        ].join('-');
      }
      return null;
    }
  }
};
